export default __webpack_public_path__ + "static/capy-b8220c1b5593d7941fb7d7aedc9fb2bb.webp";